import { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

export function FlashSaleCountdown({ endTime }) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const end = new Date(endTime);
    const now = new Date();
    const diff = end - now;

    if (diff <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(diff / (1000 * 60 * 60 * 24)),
      hours: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((diff % (1000 * 60)) / 1000),
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime]);

  return (
    <div className="flex items-center gap-3" data-testid="flash-sale-countdown">
      <Clock className="h-5 w-5 text-white" />
      <div className="flex gap-2">
        {[
          { label: 'D', value: timeLeft.days },
          { label: 'H', value: timeLeft.hours },
          { label: 'M', value: timeLeft.minutes },
          { label: 'S', value: timeLeft.seconds },
        ].map((item) => (
          <div key={item.label} className="countdown-item rounded">
            <span className="text-xl font-mono font-bold text-white">
              {String(item.value).padStart(2, '0')}
            </span>
            <span className="text-xs text-red-200 block">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
